export default "__VITE_ASSET__$oHpfAD$__"